import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import { Navigate, Outlet } from "react-router-dom";
import Cookies from "universal-cookie";
import UserSidebar from "../components/User/UserSidebar";
import "./UserWorkspace.css";
import { useLanguage } from "../i18n/LanguageContext";

const LayoutUser = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const token = new Cookies().get("token");
  const { isEnglish, direction } = useLanguage();
  if (!token) return <Navigate to="/SignIn" replace />;
  return <div className="workspace-shell" dir={direction}>
    <UserSidebar open={menuOpen} onClose={() => setMenuOpen(false)} />
    {menuOpen && <button className="workspace-backdrop" onClick={() => setMenuOpen(false)} aria-label={isEnglish ? "Close menu" : "بستن منو"} />}
    <section className="workspace-main">
      <div className="workspace-mobile-head"><button onClick={() => setMenuOpen((value) => !value)} aria-label={isEnglish ? "Menu" : "منو"}>{menuOpen ? <X /> : <Menu />}</button><strong>{isEnglish ? "User dashboard" : "پنل کاربری"}</strong></div>
      <Outlet />
    </section>
  </div>;
};

export default LayoutUser;
